export type Format = 'Zoom' | 'In-Person'
export type InstructorGroup = 'Jon Kichen' | 'Other Instructor'
export type Status = 'active' | 'cancelled'

export const CE_CATEGORIES = [
  'Agency Law',
  'Contract Law',
  'Disclosure',
  'Fair Housing',
  'General — Deed Fraud, Firewise + AZ Water',
  'Legal Issues',
  "Requirements for Licensees (formerly Commissioner's Standards)",
] as const

export type CECategory = (typeof CE_CATEGORIES)[number]

export interface ClassRecord {
  id: string
  title: string
  date: string // YYYY-MM-DD
  startTime: string // e.g., "9:00 AM"
  endTime: string // e.g., "12:00 PM"
  hours: number
  format: Format
  ceCategory: CECategory
  instructorGroup: InstructorGroup
  instructorName: string
  price: string
  location: string
  description: string
  status: Status
}

// NOTE: This is realistic SAMPLE/DEMO data for design review only — not the live schedule.
// Titles are drawn from the approved Desert Sage class title pool. Dates are valid 2026
// weekdays (Mon–Fri). This dataset is structured so real WebsiteForge data can replace it later.
export const mockClasses: ClassRecord[] = [
  // ===== JUNE 2026 (today is June 5, 2026 — all upcoming) =====
  {
    id: 'c1',
    title: 'Agency for Your Client',
    date: '2026-06-08', // Monday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'Agency Law',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'Understand your duties when representing a client, from formation of the agency relationship through closing. A practical look at Arizona agency law.',
    status: 'active',
  },
  {
    id: 'c2',
    title: 'Know Your Forms: The Residential Purchase Contract',
    date: '2026-06-09', // Tuesday
    startTime: '1:00 PM',
    endTime: '4:00 PM',
    hours: 3,
    format: 'In-Person',
    ceCategory: 'Contract Law',
    instructorGroup: 'Other Instructor',
    instructorName: 'Butch Leiber',
    price: '$25',
    location: 'Scottsdale Association of REALTORS',
    description:
      'A line-by-line walk through the AAR Residential Resale Real Estate Purchase Contract and the common mistakes agents make.',
    status: 'active',
  },
  {
    id: 'c3',
    title: 'Essentials of Disclosure',
    date: '2026-06-11', // Thursday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'Disclosure',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'A review of disclosure obligations in Arizona transactions including material facts, the SPDS, and common pitfalls.',
    status: 'active',
  },
  {
    id: 'c4',
    title: 'Fair Housing For Today',
    date: '2026-06-12', // Friday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'In-Person',
    ceCategory: 'Fair Housing',
    instructorGroup: 'Other Instructor',
    instructorName: 'Dana Kichen',
    price: 'Free',
    location: 'West Maricopa Association of REALTORS',
    description:
      'An overview of Fair Housing laws, protected classes, and how they apply to modern Arizona real estate practice.',
    status: 'active',
  },
  {
    id: 'c5',
    title: 'Deed Fraud, Firewise & AZ Water: Protect Your Client',
    date: '2026-06-15', // Monday
    startTime: '1:00 PM',
    endTime: '4:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'General — Deed Fraud, Firewise + AZ Water',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: '$20',
    location: 'Zoom',
    description:
      'NEW ADRE requirement as of 2025. Covers deed fraud prevention, firewise communities, and Arizona water issues.',
    status: 'active',
  },
  {
    id: 'c6',
    title: 'Unintentional Property Management',
    date: '2026-06-17', // Wednesday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'In-Person',
    ceCategory: 'Legal Issues',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Phoenix REALTORS',
    description:
      'How licensees accidentally cross into property management and the legal exposure that comes with it.',
    status: 'active',
  },
  {
    id: 'c7',
    title: 'Keep Your License',
    date: '2026-06-18', // Thursday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory:
      "Requirements for Licensees (formerly Commissioner's Standards)",
    instructorGroup: 'Other Instructor',
    instructorName: 'Butch Leiber',
    price: '$25',
    location: 'Zoom',
    description:
      'Review Arizona statutes and ADRE rules that most often lead to disciplinary action, and how to stay compliant.',
    status: 'active',
  },
  {
    id: 'c8',
    title: 'Buyer Representation: Building Trust',
    date: '2026-06-22', // Monday
    startTime: '1:00 PM',
    endTime: '4:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'Agency Law',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'Best practices for establishing and documenting buyer representation in the post-settlement landscape.',
    status: 'active',
  },
  {
    id: 'c9',
    title: 'BINSR In The Real World',
    date: '2026-06-23', // Tuesday
    startTime: '1:00 PM',
    endTime: '4:00 PM',
    hours: 3,
    format: 'In-Person',
    ceCategory: 'Contract Law',
    instructorGroup: 'Other Instructor',
    instructorName: 'Dana Kichen',
    price: '$20',
    location: 'Tucson Association of REALTORS',
    description:
      'A practical look at the Buyer Inspection Notice and Seller Response and how to navigate it without breaking the contract.',
    status: 'active',
  },
  {
    id: 'c10',
    title: 'To Disclose or Not To Disclose',
    date: '2026-06-25', // Thursday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'Disclosure',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'Working through the gray areas of disclosure: what must be disclosed, what should be, and what should not.',
    status: 'active',
  },
  {
    id: 'c11',
    title: 'Cure Does Not Mean Cancel',
    date: '2026-06-29', // Monday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'Contract Law',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'Understanding the cure period and notice requirements before a contract can be cancelled.',
    status: 'cancelled',
  },
  {
    id: 'c12',
    title: 'Opening Doors: Fair Housing',
    date: '2026-06-30', // Tuesday
    startTime: '1:00 PM',
    endTime: '4:00 PM',
    hours: 3,
    format: 'In-Person',
    ceCategory: 'Fair Housing',
    instructorGroup: 'Other Instructor',
    instructorName: 'Butch Leiber',
    price: '$25',
    location: 'Scottsdale Association of REALTORS',
    description:
      'A deeper exploration of fair housing history and current enforcement trends affecting Arizona agents.',
    status: 'active',
  },

  // ===== JULY 2026 =====
  {
    id: 'c13',
    title: 'Fair Housing: It’s Not Optional',
    date: '2026-07-02', // Thursday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'Fair Housing',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'Why fair housing compliance is mandatory and how everyday practices can create unintended violations.',
    status: 'active',
  },
  {
    id: 'c14',
    title: 'Survival In Arizona: Water, Fire, Deed Fraud',
    date: '2026-07-06', // Monday
    startTime: '1:00 PM',
    endTime: '4:00 PM',
    hours: 3,
    format: 'In-Person',
    ceCategory: 'General — Deed Fraud, Firewise + AZ Water',
    instructorGroup: 'Other Instructor',
    instructorName: 'Butch Leiber',
    price: '$25',
    location: 'Scottsdale Association of REALTORS',
    description:
      'Covers the new ADRE general requirement: Arizona water adequacy, firewise property issues, and deed fraud prevention.',
    status: 'active',
  },
  {
    id: 'c15',
    title: 'The Laws Matter',
    date: '2026-07-08', // Wednesday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'Legal Issues',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'A survey of statutes that affect Arizona transactions but are frequently misunderstood by licensees.',
    status: 'active',
  },
  {
    id: 'c16',
    title: 'The Rules and The Code',
    date: '2026-07-10', // Friday
    startTime: '1:00 PM',
    endTime: '4:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory:
      "Requirements for Licensees (formerly Commissioner's Standards)",
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'How ADRE rules and the NAR Code of Ethics intersect, with real-world scenarios for Arizona agents.',
    status: 'active',
  },
  {
    id: 'c17',
    title: 'Agency Should Not Be A Secret',
    date: '2026-07-14', // Tuesday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'In-Person',
    ceCategory: 'Agency Law',
    instructorGroup: 'Other Instructor',
    instructorName: 'Dana Kichen',
    price: '$20',
    location: 'Phoenix REALTORS',
    description:
      'Clarifying agency disclosure obligations so clients and customers always understand who you represent.',
    status: 'active',
  },
  {
    id: 'c18',
    title: 'What Does The Contract Say?',
    date: '2026-07-16', // Thursday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'Contract Law',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'Reading the contract for what it actually says — interpreting key clauses, timelines, and contingencies.',
    status: 'active',
  },
  {
    id: 'c19',
    title: 'Let’s Not Grow Mushrooms',
    date: '2026-07-20', // Monday
    startTime: '1:00 PM',
    endTime: '4:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'Disclosure',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'Keeping all parties informed: how to avoid leaving your clients in the dark on disclosure issues.',
    status: 'active',
  },
  {
    id: 'c20',
    title: 'In All Fairness',
    date: '2026-07-22', // Wednesday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'In-Person',
    ceCategory: 'Fair Housing',
    instructorGroup: 'Other Instructor',
    instructorName: 'Butch Leiber',
    price: '$25',
    location: 'West Maricopa Association of REALTORS',
    description:
      'Practical fair housing guidance for advertising, showings, and client communications.',
    status: 'active',
  },
  {
    id: 'c21',
    title: 'Deed Fraud, Firewise & AZ Water: Protect Your Client',
    date: '2026-07-24', // Friday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'General — Deed Fraud, Firewise + AZ Water',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'NEW ADRE requirement as of 2025. Covers deed fraud prevention, firewise communities, and Arizona water issues.',
    status: 'active',
  },
  {
    id: 'c22',
    title: 'Do You Know This Real Estate Law?',
    date: '2026-07-28', // Tuesday
    startTime: '1:00 PM',
    endTime: '4:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'Legal Issues',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'A fast-paced review of Arizona real estate laws every licensee should know cold.',
    status: 'active',
  },
  {
    id: 'c23',
    title: 'Putting Your License At Risk',
    date: '2026-07-30', // Thursday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'In-Person',
    ceCategory:
      "Requirements for Licensees (formerly Commissioner's Standards)",
    instructorGroup: 'Other Instructor',
    instructorName: 'Dana Kichen',
    price: '$20',
    location: 'Tucson Association of REALTORS',
    description:
      'Common behaviors and oversights that put an Arizona real estate license at risk, and how to avoid them.',
    status: 'active',
  },

  // ===== AUGUST 2026 =====
  {
    id: 'c24',
    title: 'You Represent Them — Now What?',
    date: '2026-08-03', // Monday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'Agency Law',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'Once representation is established, what are your ongoing duties? A practical agency law refresher.',
    status: 'active',
  },
  {
    id: 'c25',
    title: 'Recipe for A Good Contract',
    date: '2026-08-05', // Wednesday
    startTime: '1:00 PM',
    endTime: '4:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'Contract Law',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'The essential ingredients of a valid, enforceable Arizona real estate contract.',
    status: 'active',
  },
  {
    id: 'c26',
    title: 'Material or Not',
    date: '2026-08-10', // Monday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'In-Person',
    ceCategory: 'Disclosure',
    instructorGroup: 'Other Instructor',
    instructorName: 'Butch Leiber',
    price: '$25',
    location: 'Scottsdale Association of REALTORS',
    description:
      'Determining what rises to the level of a material fact that must be disclosed in Arizona.',
    status: 'active',
  },
  {
    id: 'c27',
    title: 'Homes for All: Fair Housing for Today',
    date: '2026-08-12', // Wednesday
    startTime: '1:00 PM',
    endTime: '4:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'Fair Housing',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'Modern fair housing essentials, including digital advertising and source-of-income considerations.',
    status: 'active',
  },
  {
    id: 'c28',
    title: 'Survival In Arizona: Water, Fire, Deed Fraud',
    date: '2026-08-14', // Friday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'General — Deed Fraud, Firewise + AZ Water',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'Covers the ADRE general requirement: Arizona water adequacy, firewise property issues, and deed fraud prevention.',
    status: 'active',
  },
  {
    id: 'c29',
    title: 'Laws That Protect Your Client',
    date: '2026-08-18', // Tuesday
    startTime: '1:00 PM',
    endTime: '4:00 PM',
    hours: 3,
    format: 'In-Person',
    ceCategory: 'Legal Issues',
    instructorGroup: 'Other Instructor',
    instructorName: 'Dana Kichen',
    price: '$20',
    location: 'Phoenix REALTORS',
    description:
      'Statutes and protections that benefit your clients — and how to use them in your practice.',
    status: 'active',
  },
  {
    id: 'c30',
    title: 'The Rules of Advertising',
    date: '2026-08-20', // Thursday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory:
      "Requirements for Licensees (formerly Commissioner's Standards)",
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'ADRE advertising rules for signs, social media, and online listings — staying compliant in every channel.',
    status: 'active',
  },
  {
    id: 'c31',
    title: 'Buyer Broker: Now Is The Time',
    date: '2026-08-24', // Monday
    startTime: '9:00 AM',
    endTime: '12:00 PM',
    hours: 3,
    format: 'Zoom',
    ceCategory: 'Contract Law',
    instructorGroup: 'Jon Kichen',
    instructorName: 'Jon Kichen',
    price: 'Free',
    location: 'Zoom',
    description:
      'Implementing written buyer-broker agreements correctly under current Arizona practice.',
    status: 'active',
  },
  {
    id: 'c32',
    title: 'Why Not Disclose It?',
    date: '2026-08-27', // Thursday
    startTime: '1:00 PM',
    endTime: '4:00 PM',
    hours: 3,
    format: 'In-Person',
    ceCategory: 'Disclosure',
    instructorGroup: 'Other Instructor',
    instructorName: 'Butch Leiber',
    price: '$25',
    location: 'West Maricopa Association of REALTORS',
    description:
      'When in doubt, disclose: managing risk by erring on the side of transparency.',
    status: 'active',
  },
]
